module.exports = __webpack_public_path__ + "static/img/369_phase_function_Paper_PointsHejduk_Prediction.abf7d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/369_phase_function_Paper_PointsHejduk_Prediction.png
// module id = iEmU
// module chunks = 0